var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.pconUrl
    ? _c(
        "div",
        { staticClass: "row" },
        [
          _vm.attributes.length ||
          (Object.keys(_vm.possibleUnits).length > 1 && _vm.isContentVisible)
            ? [
                _vm._l(_vm.attributes, function(attribute) {
                  return _c(
                    "div",
                    {
                      staticClass: "col-12 single__variations-select",
                      class: {
                        "col-md-6":
                          attribute.attributeId != 20 &&
                          attribute.attributeId != 120 &&
                          attribute.attributeId != 42 &&
                          attribute.attributeId != 43
                      }
                    },
                    [
                      attribute.type === "dropdown"
                        ? _c(
                            "div",
                            {
                              ref: "attributesContaner",
                              refInFor: true,
                              staticClass: "position-relative"
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "single__variations-select-label"
                                },
                                [_vm._v(_vm._s(attribute.name))]
                              ),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  on: {
                                    change: function($event) {
                                      return _vm.selectAttribute(
                                        attribute.attributeId,
                                        $event.target.value
                                      )
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "option",
                                    {
                                      domProps: {
                                        value: null,
                                        selected:
                                          _vm.selectedAttributes[
                                            attribute.attributeId
                                          ] === null
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$translate(
                                            "Ceres::Template.singleItemPleaseSelect"
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm._l(attribute.values, function(value) {
                                    return _c(
                                      "option",
                                      {
                                        key: value.attributeValueId,
                                        domProps: {
                                          value: value.attributeValueId,
                                          selected:
                                            value.attributeValueId ===
                                            _vm.selectedAttributes[
                                              attribute.attributeId
                                            ]
                                        }
                                      },
                                      [
                                        _vm.isAttributeSelectionValid(
                                          attribute.attributeId,
                                          value.attributeValueId
                                        )
                                          ? [
                                              _vm._v(
                                                "\n                            " +
                                                  _vm._s(value.name) +
                                                  "\n                        "
                                              )
                                            ]
                                          : _vm.isAttributeSelectionValid(
                                              attribute.attributeId,
                                              value.attributeValueId,
                                              false
                                            )
                                          ? [
                                              _vm._v(
                                                "\n                            " +
                                                  _vm._s(
                                                    _vm.$translate(
                                                      "Ceres::Template.singleItemNotSalableAttribute",
                                                      { name: value.name }
                                                    )
                                                  ) +
                                                  "\n                        "
                                              )
                                            ]
                                          : [
                                              _vm._v(
                                                "\n                            " +
                                                  _vm._s(
                                                    _vm.$translate(
                                                      "Ceres::Template.singleItemInvalidAttribute",
                                                      { name: value.name }
                                                    )
                                                  ) +
                                                  "\n                        "
                                              )
                                            ]
                                      ],
                                      2
                                    )
                                  })
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "svg",
                                {
                                  staticClass: "single__select--up",
                                  attrs: { height: "7", width: "11" }
                                },
                                [
                                  _c("use", {
                                    attrs: {
                                      "xlink:href": "#svg_arrow",
                                      "xmlns:xlink":
                                        "http://www.w3.org/1999/xlink"
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "svg",
                                {
                                  staticClass: "single__select--down",
                                  attrs: { height: "7", width: "11" }
                                },
                                [
                                  _c("use", {
                                    attrs: {
                                      "xlink:href": "#svg_arrow",
                                      "xmlns:xlink":
                                        "http://www.w3.org/1999/xlink"
                                    }
                                  })
                                ]
                              )
                            ]
                          )
                        : attribute.type === "box" || attribute.type === "image"
                        ? _c("div", [
                            _c(
                              "span",
                              {
                                staticClass: "single__variations-select-label"
                              },
                              [_vm._v(_vm._s(attribute.name) + ":")]
                            ),
                            _vm._v(" "),
                            _c("b", [
                              _vm._v(
                                _vm._s(
                                  _vm.getSelectedAttributeValueName(attribute)
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "v-s-boxes py-3",
                                class: { images: attribute.type === "image" }
                              },
                              _vm._l(attribute.values, function(value) {
                                return _c(
                                  "div",
                                  {
                                    key: value.attributeValueId,
                                    staticClass: "v-s-box bg-white",
                                    class: {
                                      active:
                                        value.attributeValueId ===
                                        _vm.selectedAttributes[
                                          attribute.attributeId
                                        ],
                                      invalid: !_vm.isAttributeSelectionValid(
                                        attribute.attributeId,
                                        value.attributeValueId
                                      )
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.selectAttribute(
                                          attribute.attributeId,
                                          value.attributeValueId
                                        )
                                      }
                                    }
                                  },
                                  [
                                    attribute.type === "box"
                                      ? _c("span", { staticClass: "mx-3" }, [
                                          _vm._v(_vm._s(value.name))
                                        ])
                                      : _c("img", {
                                          staticClass: "p-1",
                                          attrs: {
                                            src: value.imageUrl,
                                            alt: value.name
                                          }
                                        })
                                  ]
                                )
                              }),
                              0
                            )
                          ])
                        : _vm._e()
                    ]
                  )
                }),
                _vm._v(" "),
                Object.keys(_vm.units).length > 1
                  ? _c(
                      "div",
                      {
                        staticClass: "col-12 col-md-6 single__variations-select"
                      },
                      [
                        _c("div", { staticClass: "position-relative" }, [
                          _c(
                            "select",
                            {
                              on: {
                                change: function($event) {
                                  return _vm.selectUnit($event.target.value)
                                }
                              }
                            },
                            [
                              _c("option", { domProps: { value: null } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "Ceres::Template.singleItemContent"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.units, function(unit, unitId) {
                                return _c(
                                  "option",
                                  {
                                    domProps: {
                                      value: unitId,
                                      selected:
                                        parseInt(unitId) === _vm.selectedUnit
                                    }
                                  },
                                  [
                                    _vm.isUnitSelectionValid(unitId)
                                      ? [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(unit) +
                                              "\n                        "
                                          )
                                        ]
                                      : [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(
                                                _vm.$translate(
                                                  "Ceres::Template.singleItemInvalidAttribute",
                                                  { name: unit }
                                                )
                                              ) +
                                              "\n                        "
                                          )
                                        ]
                                  ],
                                  2
                                )
                              })
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "svg",
                            {
                              staticClass: "single__select--up",
                              attrs: { height: "7", width: "11" }
                            },
                            [
                              _c("use", {
                                attrs: {
                                  "xlink:href": "#svg_arrow",
                                  "xmlns:xlink": "http://www.w3.org/1999/xlink"
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "svg",
                            {
                              staticClass: "single__select--down",
                              attrs: { height: "7", width: "11" }
                            },
                            [
                              _c("use", {
                                attrs: {
                                  "xlink:href": "#svg_arrow",
                                  "xmlns:xlink": "http://www.w3.org/1999/xlink"
                                }
                              })
                            ]
                          )
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            : [_vm._t("default")]
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }